import React from "react"
import { PaymentTransactionStatus, PaymentTransactionStatusEnum } from "@cruisen/contract"
import styles from "./styles.module.scss"
import classNames from "classnames"

type PaymentStatusCategory = "error" | "pending" | "success"

const getPaymentStatusCategory = (
  status: PaymentTransactionStatusEnum | "success" | "warning",
): PaymentStatusCategory => {
  if (status === PaymentTransactionStatusEnum.Succeeded || status === "success") return "success"
  if (
    [
      PaymentTransactionStatusEnum.ACHProcessing,
      PaymentTransactionStatusEnum.Approved,
      "warning",
    ].includes(status)
  )
    return "pending"
  return "error"
}

const paymentStatus = {
  ACHProcessing: "Processing",
  ACHFailed: "Failed",
  approved: "Approved",
  succeeded: "Succeeded",
  cancelled: "Cancelled",
  failed: "Failed",
}

const PaymentStatusChip = ({
  status,
  value,
}: {
  status: PaymentTransactionStatus
  value?: string
}) => {
  const statusCategory = getPaymentStatusCategory(status as PaymentTransactionStatusEnum)
  const statusText = value || paymentStatus[status] || status

  return <div className={classNames(styles.statusChip, styles[statusCategory])}>{statusText}</div>
}

export const PaymentInfoWrapper = ({
  paymentData,
  children,
  testID,
}: {
  paymentData: { label: string; value: string; status?: string }[]
  children?: React.ReactNode
  testID?: string
}) => {
  return (
    <div className={styles.wrapper} data-testid={testID}>
      {paymentData.map((paymentRow) => (
        <div className={styles.row} key={paymentRow.label}>
          <div className={styles.label}>{paymentRow.label}</div>
          {paymentRow.status ? (
            <PaymentStatusChip
              status={paymentRow.status as PaymentTransactionStatus}
              value={paymentRow.value || ""}
            />
          ) : (
            <div className={styles.value}>{paymentRow.value}</div>
          )}
        </div>
      ))}
      {children}
    </div>
  )
}
